import React, { useState } from 'react'

import { Grid, Typography, Stack } from '@mui/material'

import { Search } from 'components'
import { vhMinus } from 'utils/textZoom'

export const SearchPage = () => {
  return (
    <Grid container justifyContent="center" alignItems="center" height={vhMinus()}>
      <Grid item xs={12} sm={8} md={6} alignItems="center" justifyContent="center">
        <Stack direction="column" alignItems="center" justifyContent="center">
          <Typography variant="h1" fontWeight="light" pb={8}>
            Coming soon
          </Typography>
          <Search sx={{minWidth: "100%"}} />
        </Stack>
      </Grid>
    </Grid>
  )
}